module.exports = {
  siteTitle: 'Akash',
  siteDescription:
    'I\'m just a guy who\'s a programmer for fun!',
  siteKeywords:
    'akash g, akash, akashsuper2000, software engineer, data scientist, python, akash, amrita, stony brook, new york, sbu, student, machine learning, artificial intelligence, deep learning, developer, computer, science, computer science',
  siteUrl: 'https://akashsuper2000.github.io',
  siteLanguage: 'en_US',
  googleAnalyticsID: 'UA-142543873-2', // to be filled UA-45666519-2
  googleVerification: 'R-ETv5A3BWjoOiEO4iRXx7sUv8TE2f5cunTW4smwOvw', // to be filled DCl7VAf9tcz6eD9gb67NfkNnJ1PKRNcg8qQiwpbx9Lk
  name: 'Akash',
  location: 'New York, US',
  email: 'akashsuper2000@gmail.com',
  github: 'https://github.com/akashsuper2000',
  twitterHandle: '@akashsuper2000',
  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/akashsuper2000',
    },
    {
      name: 'Linkedin',
      url: 'https://linkedin.com/in/akash-g',
    },
    {
      name: 'Hackerrank',
      url: 'https://hackerrank.com/akashsuper2000',
    },
    {
      name: 'CodeChef',
      url: 'https://codechef.com/users/akash2000coder',
    },
    {
      name: 'Kaggle',
      url: 'https://kaggle.com/akashsuper2000',
    },
    {
      name: 'CTFTime',
      url: 'https://ctftime.org/team/82868',
    },
    {
      name: 'CodeForces',
      url: 'https://codeforces.com/profile/akash2000',
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/akashsuper2000',
    },
    // {
    //   name: 'Medium',
    //   url: 'https://medium.com/@akashsuper2000',
    // },
    // {
    //   name: 'Dev',
    //   url: 'https://dev.to/akashsuper2000',
    // },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Study',
      url: '/#study',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Projects',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  navHeight: 100,

  colors: {
    green: '#64ffda',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 0, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
